// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpaceDemoPopup__popup-b3499f {
  background-color: var(--brand-primary-40);
  border: none;
  justify-content: space-between;
  padding-top: 40px;
  padding-bottom: 24px;
  max-height: 600px;
  position: relative;
  --slider-animation-duration: 0.25s;
}

.SpaceDemoPopup__close-cc7ad1 {
  position: absolute;
  inset-inline-end: 10px;
  top: 10px;
}

.SpaceDemoPopup__slide-d7c1e2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-inline-start: 24px;
  padding-inline-end: 24px;
  margin-bottom: 24px;
  overflow: auto;
}

.SpaceDemoPopup__slide-enter-b6e1ef {
  opacity: 0;
}

.SpaceDemoPopup__slide-enter-active-e9f50d {
  opacity: 1;
}

.SpaceDemoPopup__slide-exit-ae677a {
  opacity: 1;
}

.SpaceDemoPopup__slide-exit-active-de4b18 {
  opacity: 0;
}

.SpaceDemoPopup__slide-enter-active-e9f50d,
.SpaceDemoPopup__slide-exit-active-de4b18 {
  transition: opacity var(--slider-animation-duration) linear;
}

.SpaceDemoPopup__image-c7b4d1 {
  margin-bottom: 8px;
  max-height: 300px;
  min-height: 150px;
}

.SpaceDemoPopup__title-afbf48 {
  color: var(--addition-50);
  font: var(--font-title-6);
  letter-spacing: var(--font-spacing-title-6);
  margin-bottom: 16px;
  text-align: center;
}

.SpaceDemoPopup__description-eee05e {
  color: var(--addition-50);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  margin-bottom: 16px;
  text-align: center;
}

.SpaceDemoPopup__action-a86568 {
  flex-shrink: 0;
}

.SpaceDemoPopup__stepper-e941f7 {
  display: flex;
  gap: 4px;
  justify-content: center;
}

.SpaceDemoPopup__step-eef02e {
  align-items: center;
  display: flex;
  justify-content: center;
  cursor: pointer;
  height: 16px;
  width: 16px;
}

.SpaceDemoPopup__step-pin-b0020c {
  background-color: var(--addition-50_30);
  border-radius: 50%;
  height: 8px;
  width: 8px;
}

.SpaceDemoPopup__step-eef02e.SpaceDemoPopup__active-e3f28b .SpaceDemoPopup__step-pin-b0020c {
  background-color: var(--addition-50);
}

.SpaceDemoPopup__left-button-fc585f,
.SpaceDemoPopup__right-button-c810b7 {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto 0;
}

.SpaceDemoPopup__left-button-fc585f {
  inset-inline-start: 8px;
}

.SpaceDemoPopup__right-button-c810b7 {
  inset-inline-end: 8px;
}

@media (max-height: 500px) {
  .SpaceDemoPopup__popup-b3499f {
    padding-top: 20px;
    padding-bottom: 18px;
  }
  .SpaceDemoPopup__title-afbf48 {
    font: var(--font-title-8);
    letter-spacing: var(--font-spacing-title-8);
    margin-bottom: 8px;
  }
  .SpaceDemoPopup__description-eee05e {
    margin-bottom: 8px;
    font: var(--font-subtitle-4);
    letter-spacing: var(--font-spacing-subtitle-4);
  }
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/SpaceDemoPopup/SpaceDemoPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,yCAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,kCAAA;AAAF;;AAGA;EACE,kBAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;EACA,wBAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;;EAEE,2DAAA;AAAF;;AAGA;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,yBAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,wBAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,QAAA;EACA,uBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AAAF;;AAGA;EACE,uCAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AAAF;;AAGA;EACE,oCAAA;AAAF;;AAGA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE;IACE,iBAAA;IACA,oBAAA;EAAF;EAGA;IACE,yBAAA;IACA,2CAAA;IACA,kBAAA;EADF;EAIA;IACE,kBAAA;IACA,4BAAA;IACA,8CAAA;EAFF;AACF","sourcesContent":[".popup {\n  background-color: var(--brand-primary-40);\n  border: none;\n  justify-content: space-between;\n  padding-top: 40px;\n  padding-bottom: 24px;\n  max-height: 600px;\n  position: relative;\n\n  --slider-animation-duration: 0.25s;\n}\n\n.close {\n  position: absolute;\n  inset-inline-end: 10px;\n  top: 10px;\n}\n\n.slide {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-inline-start: 24px;\n  padding-inline-end: 24px;\n  margin-bottom: 24px;\n  overflow: auto;\n}\n\n.slide-enter {\n  opacity: 0;\n}\n\n.slide-enter-active {\n  opacity: 1;\n}\n\n.slide-exit {\n  opacity: 1;\n}\n\n.slide-exit-active {\n  opacity: 0;\n}\n\n.slide-enter-active,\n.slide-exit-active {\n  transition: opacity var(--slider-animation-duration) linear;\n}\n\n.image {\n  margin-bottom: 8px;\n  max-height: 300px;\n  min-height: 150px;\n}\n\n.title {\n  color: var(--addition-50);\n  font: var(--font-title-6);\n  letter-spacing: var(--font-spacing-title-6);\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.description {\n  color: var(--addition-50);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.action {\n  flex-shrink: 0;\n}\n\n.stepper {\n  display: flex;\n  gap: 4px;\n  justify-content: center;\n}\n\n.step {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  height: 16px;\n  width: 16px;\n}\n\n.step-pin {\n  background-color: var(--addition-50_30);\n  border-radius: 50%;\n  height: 8px;\n  width: 8px;\n}\n\n.step.active .step-pin {\n  background-color: var(--addition-50);\n}\n\n.left-button,\n.right-button {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  margin: auto 0;\n}\n\n.left-button {\n  inset-inline-start: 8px;\n}\n\n.right-button {\n  inset-inline-end: 8px;\n}\n\n@media (max-height: 500px) {\n  .popup {\n    padding-top: 20px;\n    padding-bottom: 18px;\n  }\n\n  .title {\n    font: var(--font-title-8);\n    letter-spacing: var(--font-spacing-title-8);\n    margin-bottom: 8px;\n  }\n\n  .description {\n    margin-bottom: 8px;\n    font: var(--font-subtitle-4);\n    letter-spacing: var(--font-spacing-subtitle-4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `SpaceDemoPopup__popup-b3499f`,
	"close": `SpaceDemoPopup__close-cc7ad1`,
	"slide": `SpaceDemoPopup__slide-d7c1e2`,
	"slide-enter": `SpaceDemoPopup__slide-enter-b6e1ef`,
	"slideEnter": `SpaceDemoPopup__slide-enter-b6e1ef`,
	"slide-enter-active": `SpaceDemoPopup__slide-enter-active-e9f50d`,
	"slideEnterActive": `SpaceDemoPopup__slide-enter-active-e9f50d`,
	"slide-exit": `SpaceDemoPopup__slide-exit-ae677a`,
	"slideExit": `SpaceDemoPopup__slide-exit-ae677a`,
	"slide-exit-active": `SpaceDemoPopup__slide-exit-active-de4b18`,
	"slideExitActive": `SpaceDemoPopup__slide-exit-active-de4b18`,
	"image": `SpaceDemoPopup__image-c7b4d1`,
	"title": `SpaceDemoPopup__title-afbf48`,
	"description": `SpaceDemoPopup__description-eee05e`,
	"action": `SpaceDemoPopup__action-a86568`,
	"stepper": `SpaceDemoPopup__stepper-e941f7`,
	"step": `SpaceDemoPopup__step-eef02e`,
	"step-pin": `SpaceDemoPopup__step-pin-b0020c`,
	"stepPin": `SpaceDemoPopup__step-pin-b0020c`,
	"active": `SpaceDemoPopup__active-e3f28b`,
	"left-button": `SpaceDemoPopup__left-button-fc585f`,
	"leftButton": `SpaceDemoPopup__left-button-fc585f`,
	"right-button": `SpaceDemoPopup__right-button-c810b7`,
	"rightButton": `SpaceDemoPopup__right-button-c810b7`
};
module.exports = ___CSS_LOADER_EXPORT___;
